import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { Carnet, CarnetInfo } from '../../shared/interface';

@Component({
  selector: 'app-carnet',
  templateUrl: './carnet.component.html',
  styleUrl: './carnet.component.css',
  encapsulation: ViewEncapsulation.None
})
export class CarnetComponent implements OnInit {

  constructor (private apiService: ApiService, private router: Router) {}

  carnets: Carnet[] = [];
  carnet_info?: CarnetInfo;

  ngOnInit(): void {

    this.apiService.getCarnetInfo().subscribe({
      next: (data) => {
        if (!data?.attivo) {
          this.router.navigate(['/']);
          return;
        }

        this.carnet_info = data;

        this.apiService.getCarnets().subscribe({
          next: (carnets) => this.carnets = [...carnets],
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message)
        });
      },
      error: (err) => {
        this.apiService.message('error', 'Errore', err.error.message.message);
        this.router.navigate(['/']);
      }
    })

  }
}
